import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  useLenis();
  return (
    <div className="App">
      <Toaster position="top-center" theme="dark" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Legal />} />
          <Route path="/terms" element={<Legal />} />
          <Route path="/refund" element={<Legal />} />
          <Route path="/disclaimer" element={<Legal />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
